import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/SignUp";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const SignUpMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="SignUp">
      <MobileNotice page="SignUp" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default SignUpMobile;